<template>
  <div class="zoom-org">
    <div v-if="zoomCount">
      <p><em>{{ information }}</em></p>
      <span class="block" v-for="zoom in zooms">
      <a target="_blank" :href="zoom.zoom_link">{{ zoom.organization }}</a> <span class="delimiter"> / </span>
    </span>
      <hr>
    </div>
  </div>
</template>

<script>
export default {
  name: "AdvertDisplay",
  computed: {
    zoomCount() {
      return this.zooms.length;
    },

  },
  props:
      {
        information: {
          type: String,
          required: true
        },
      },

  data() {
    return {
      zooms: []
    }
  },

  methods: {

    getImage() {

    },

    fetchItems() {

      //this.rand = Math.floor(Math.random() * Math.floor(1000));
      //return;
      axios.get('/organizations/zoom/open.json')
          .then(response => (this.zooms = response.data));

    },


    create() {
      axios.post(this.endpoint);

      this.active = true;
      this.count++;
    },

    destroy() {
      axios.delete(this.endpoint);

      this.active = false;
      this.count--;
    }
  },

  beforeCreate() {

  },
  created() {
    this.fetchItems();
    setInterval(function () {
      this.fetchItems();
    }.bind(this), 30000);
  },
  beforeMount() {

  },
  mounted() {

  },
  beforeUpdate() {

  },
  updated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  }


};
</script>

<style scoped>


</style>